import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, input, Input, output, Output, ViewChild } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { EComponentSize, EIcon } from '../../types';
import { Types } from 'shared-lib';

@Component({
  selector: 'ui-step-progress',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './step-progress.component.html',
  styleUrls: ['./step-progress.component.scss']
})
export class StepProgressComponent {
  steps = input.required<{name: string}[]>();
  currentStep = input<number>(0);

  stepChange = output<number>();

  EIcon = EIcon;
  EAlert = Types.EAlert;
  EComponentSize = EComponentSize;
  showArrows = false;

  @ViewChild('carousel', { static: false }) carousel!: ElementRef;

  onTab(event: Event, index: number): void {
    event.preventDefault();
    this.stepChange.emit(index);
  }

  ngAfterViewInit() {
    this.checkScroll();
  }

  scrollLeft() {
    this.carousel.nativeElement.scrollBy({ left: -150, behavior: 'smooth' });
    this.checkScroll();
  }

  scrollRight() {
    this.carousel.nativeElement.scrollBy({ left: 150, behavior: 'smooth' });
    this.checkScroll();
  }

  checkScroll() {
    setTimeout(() => {
      const el = this.carousel.nativeElement;
      this.showArrows = el.scrollWidth > el.clientWidth;
    }, 100);
  }
}
